import React from 'react';
import { SymptomDto } from '../interfaces/symptom';

interface SymptomSelectorProps {
    sintomasCatalogo: SymptomDto[];
    value: number[];
    onChange: (ids: number[]) => void;
}

const SymptomSelector: React.FC<SymptomSelectorProps> = ({ sintomasCatalogo, value, onChange }) => {
    const handleToggle = (id: number) => {
        if (value.includes(id)) {
            onChange(value.filter((s) => s !== id));
        } else {
            onChange([...value, id]);
        }
    };
    return (
        <div className='button-grid'>
            {sintomasCatalogo.map((sintoma) => {
                const sintomaId = typeof sintoma.id_sintoma === 'number' ? sintoma.id_sintoma : Number(sintoma.id_sintoma);
                return (
                    <button
                        key={sintomaId}
                        className={`option-button${value.includes(sintomaId) ? ' selected' : ''}`}
                        onClick={() => handleToggle(sintomaId)}
                        type='button'
                    >
                        {sintoma.nombre_sintoma}
                    </button>
                );
            })}
        </div>
    );
};

export default SymptomSelector;
